import React from 'react';
import { getBlogsSelector } from '../../ducks/strapi.duck';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import css from './CustomerLandingPage.module.css';
import '../../styles/slick/slick.css';
import '../../styles/slick/slick-theme.css';

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      },
    },
  ],
};

function SectionBlogs() {
  const blogsData = useSelector(getBlogsSelector) || [];
  const history = useHistory();

  const onRedirectToPage = (page, params = {}, search = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration(), params, search));
  };

  return (
    <div className={css.blogSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.mainTitle}>
          <h2>Blogs</h2>
        </div>
        <div className={css.howItWorks}>
          {blogsData.length > 0 ? (
            <Slider {...settings}>
              {blogsData.map((blog, index) => (
                <div
                  key={blog.id || index}
                  className={css.workBlock}
                  role="button"
                  tabIndex={0}
                  onClick={() => onRedirectToPage('SingleBlogPage', { title: blog.slug })}
                >
                  <div className={css.workImg}>
                    <img
                      src={blog?.coverImage?.formats?.medium?.url || blog?.coverImage?.url}
                      alt={blog.title}
                    />
                  </div>
                  <div className={css.workInfo}>
                    <h2>{blog.title}</h2>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <p>No blogs available at the moment. Please check back later.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SectionBlogs;
